module.exports = __webpack_public_path__ + "static/media/donate-tablet.d3005861.svg";